import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import pl.mothdigital.neuronowi.pages.ChildProtectionStandardsPage as _pl_mothdigital_neuronowi_pages_ChildProtectionStandardsPage
import pl.mothdigital.neuronowi.pages.HomePage as _pl_mothdigital_neuronowi_pages_HomePage
import pl.mothdigital.neuronowi.pages.PrivacyPolicyPage as _pl_mothdigital_neuronowi_pages_PrivacyPolicyPage
import pl.mothdigital.neuronowi.pages.StatutPage as _pl_mothdigital_neuronowi_pages_StatutPage
import pl.mothdigital.neuronowi.pages.TermsAndConditionsPage as _pl_mothdigital_neuronowi_pages_TermsAndConditionsPage
import pl.mothdigital.neuronowi.pages.about.AboutPage as _pl_mothdigital_neuronowi_pages_about_AboutPage
import pl.mothdigital.neuronowi.pages.contact.ContactPage as _pl_mothdigital_neuronowi_pages_contact_ContactPage
import pl.mothdigital.neuronowi.pages.specialists.AnnaPetrusPage as _pl_mothdigital_neuronowi_pages_specialists_AnnaPetrusPage
import pl.mothdigital.neuronowi.pages.specialists.EwaSofinskaPage as _pl_mothdigital_neuronowi_pages_specialists_EwaSofinskaPage
import pl.mothdigital.neuronowi.pages.specialists.JuliaSiutaPage as _pl_mothdigital_neuronowi_pages_specialists_JuliaSiutaPage
import pl.mothdigital.neuronowi.pages.specialists.MagdalenaBanachPage as _pl_mothdigital_neuronowi_pages_specialists_MagdalenaBanachPage
import pl.mothdigital.neuronowi.pages.specialists.MagdalenaNowikPage as _pl_mothdigital_neuronowi_pages_specialists_MagdalenaNowikPage
import pl.mothdigital.neuronowi.pages.specialists.MartaDybalskaPage as _pl_mothdigital_neuronowi_pages_specialists_MartaDybalskaPage
import pl.mothdigital.neuronowi.pages.specialists.PatrycjaOchryniukPage as _pl_mothdigital_neuronowi_pages_specialists_PatrycjaOchryniukPage
import pl.mothdigital.neuronowi.pages.specialists.PaulinaKoniecznaPage as _pl_mothdigital_neuronowi_pages_specialists_PaulinaKoniecznaPage
import pl.mothdigital.neuronowi.pages.specialists.RadoslawNitschkePage as _pl_mothdigital_neuronowi_pages_specialists_RadoslawNitschkePage
import pl.mothdigital.neuronowi.pages.specialists.SpecialistsPage as _pl_mothdigital_neuronowi_pages_specialists_SpecialistsPage
import pl.mothdigital.neuronowi.pages.specialists.ZaklinaWykretPage as _pl_mothdigital_neuronowi_pages_specialists_ZaklinaWykretPage
import pl.mothdigital.neuronowi.pages.therapies.TherapiesPage as _pl_mothdigital_neuronowi_pages_therapies_TherapiesPage
import pl.mothdigital.neuronowi.pages.therapies.fizjoterapia.TherapyPhysioPage as _pl_mothdigital_neuronowi_pages_therapies_fizjoterapia_TherapyPhysioPage
import pl.mothdigital.neuronowi.pages.therapies.integracjaSensoryczna.TherapySensoryIntegrationPage as _pl_mothdigital_neuronowi_pages_therapies_integracjaSensoryczna_TherapySensoryIntegrationPage
import pl.mothdigital.neuronowi.pages.therapies.terapiaLogopedyczna.TherapyLogopedicPage as _pl_mothdigital_neuronowi_pages_therapies_terapiaLogopedyczna_TherapyLogopedicPage
import pl.mothdigital.neuronowi.pages.therapies.terapiaMiofunkcjonalna.TherapyMiofunctionalPage as _pl_mothdigital_neuronowi_pages_therapies_terapiaMiofunkcjonalna_TherapyMiofunctionalPage
import pl.mothdigital.neuronowi.pages.therapies.terapiaNeurotaktylna.TherapyNeurotactilePage as _pl_mothdigital_neuronowi_pages_therapies_terapiaNeurotaktylna_TherapyNeurotactilePage
import pl.mothdigital.neuronowi.pages.therapies.terapiaReki.TherapyHandPage as _pl_mothdigital_neuronowi_pages_therapies_terapiaReki_TherapyHandPage
import pl.mothdigital.neuronowi.pages.therapies.terapiaSluchowa.TherapyAuditoryPage as _pl_mothdigital_neuronowi_pages_therapies_terapiaSluchowa_TherapyAuditoryPage
import pl.mothdigital.neuronowi.pages.therapies.wsparcePsychologiczne.TherapyPsychologicalPage as _pl_mothdigital_neuronowi_pages_therapies_wsparcePsychologiczne_TherapyPsychologicalPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Neuronowi"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_HomePage()
        }
        ctx.router.register(
            "/about/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_about_AboutPage()
        }
        ctx.router.register(
            "/child-protection-standards",
            initRouteMethod = { ctx ->
                pl.mothdigital.neuronowi.pages.initChildProtectionStandardsPage(ctx)
            },
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_ChildProtectionStandardsPage()
        }
        ctx.router.register(
            "/contact/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_contact_ContactPage()
        }
        ctx.router.register(
            "/privacy-policy",
            initRouteMethod = { ctx ->
                pl.mothdigital.neuronowi.pages.initPrivacyPolicyPage(ctx)
            },
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/specialists/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_SpecialistsPage()
        }
        ctx.router.register(
            "/specialists/anna-petrus-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_AnnaPetrusPage()
        }
        ctx.router.register(
            "/specialists/ewa-sofinska-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_EwaSofinskaPage()
        }
        ctx.router.register(
            "/specialists/julia-siuta-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_JuliaSiutaPage()
        }
        ctx.router.register(
            "/specialists/magdalena-banach-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_MagdalenaBanachPage()
        }
        ctx.router.register(
            "/specialists/magdalena-nowik-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_MagdalenaNowikPage()
        }
        ctx.router.register(
            "/specialists/marta-dybalska-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_MartaDybalskaPage()
        }
        ctx.router.register(
            "/specialists/patrycja-ochryniuk-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_PatrycjaOchryniukPage()
        }
        ctx.router.register(
            "/specialists/paulina-konieczna-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_PaulinaKoniecznaPage()
        }
        ctx.router.register(
            "/specialists/radoslaw-nitschke-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_RadoslawNitschkePage()
        }
        ctx.router.register(
            "/specialists/zaklina-wykret-page",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_specialists_ZaklinaWykretPage()
        }
        ctx.router.register(
            "/statut",
            initRouteMethod = { ctx ->
                pl.mothdigital.neuronowi.pages.initStatutPage(ctx)
            },
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_StatutPage()
        }
        ctx.router.register(
            "/terms-and-conditions",
            initRouteMethod = { ctx ->
                pl.mothdigital.neuronowi.pages.initTermsAndConditionsPage(ctx)
            },
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_TermsAndConditionsPage()
        }
        ctx.router.register(
            "/therapies/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_TherapiesPage()
        }
        ctx.router.register(
            "/therapies/fizjoterapia/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_fizjoterapia_TherapyPhysioPage()
        }
        ctx.router.register(
            "/therapies/integracja-sensoryczna/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_integracjaSensoryczna_TherapySensoryIntegrationPage()
        }
        ctx.router.register(
            "/therapies/terapia-logopedyczna/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_terapiaLogopedyczna_TherapyLogopedicPage()
        }
        ctx.router.register(
            "/therapies/terapia-miofunkcjonalna/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_terapiaMiofunkcjonalna_TherapyMiofunctionalPage()
        }
        ctx.router.register(
            "/therapies/terapia-neurotaktylna/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_terapiaNeurotaktylna_TherapyNeurotactilePage()
        }
        ctx.router.register(
            "/therapies/terapia-reki/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_terapiaReki_TherapyHandPage()
        }
        ctx.router.register(
            "/therapies/terapia-sluchowa/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_terapiaSluchowa_TherapyAuditoryPage()
        }
        ctx.router.register(
            "/therapies/wsparce-psychologiczne/",
        ) { pageCtx -> 
            _pl_mothdigital_neuronowi_pages_therapies_wsparcePsychologiczne_TherapyPsychologicalPage()
        }

        pl.mothdigital.neuronowi.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer-diver", pl.mothdigital.neuronowi.components.sections.footer.FooterDiverStyle)
        ctx.theme.registerStyle("footer", pl.mothdigital.neuronowi.components.sections.footer.FooterStyle)
        ctx.theme.registerStyle("footer-logo-image", pl.mothdigital.neuronowi.components.sections.footer.FooterLogoImageStyle)
        ctx.theme.registerStyle("hero-balanced", pl.mothdigital.neuronowi.components.sections.home.hero.HeroBalancedStyle)
        ctx.theme.registerStyle("nav-header", pl.mothdigital.neuronowi.components.sections.navheader.NavHeaderStyle)
        ctx.theme.registerStyle("markdown", pl.mothdigital.neuronowi.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("price-table", pl.mothdigital.neuronowi.components.PriceTableStyle)
        ctx.theme.registerStyle("p", pl.mothdigital.neuronowi.components.text.PStyle)
        ctx.theme.registerStyle("h3", pl.mothdigital.neuronowi.components.text.H3Style)
        ctx.theme.registerStyle("h2", pl.mothdigital.neuronowi.components.text.H2Style)
        ctx.theme.registerStyle("h1", pl.mothdigital.neuronowi.components.text.H1Style)
        ctx.theme.registerStyle("instagram-button", pl.mothdigital.neuronowi.components.widgets.InstagramButtonStyle)
        ctx.theme.registerStyle("close-button", pl.mothdigital.neuronowi.components.widgets.CloseButtonStyle)
        ctx.theme.registerStyle("skip-link", pl.mothdigital.neuronowi.components.widgets.SkipLinkStyle)
        ctx.theme.registerStyle("facebook-button", pl.mothdigital.neuronowi.components.widgets.FacebookButtonStyle)
        ctx.theme.registerStyle("nav-item-text", pl.mothdigital.neuronowi.components.widgets.NavItemTextStyle)
        ctx.theme.registerStyle("hamburger-button", pl.mothdigital.neuronowi.components.widgets.HamburgerButtonStyle)
        ctx.theme.registerStyle("breadcrumbs-container", pl.mothdigital.neuronowi.components.widgets.BreadcrumbsContainerStyle)
        ctx.theme.registerStyle("breadcrumb-link", pl.mothdigital.neuronowi.components.widgets.BreadcrumbLinkStyle)
        ctx.theme.registerStyle("text-base", pl.mothdigital.neuronowi.theme.text.TextBaseStyle)
        ctx.theme.registerStyle("no-wrap-text", pl.mothdigital.neuronowi.theme.text.NoWrapTextStyle)
        ctx.theme.registerStyle("therapy-card", pl.mothdigital.neuronowi.pages.therapies.TherapyCardStyle)
        ctx.theme.registerStyle("specialist-card", pl.mothdigital.neuronowi.pages.specialists.SpecialistCardStyle)
        ctx.theme.registerVariant("-circle", pl.mothdigital.neuronowi.components.widgets.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", pl.mothdigital.neuronowi.components.widgets.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", pl.mothdigital.neuronowi.components.sections.sidemenu.SideMenuSlideInAnim)
        pl.mothdigital.neuronowi.initSiteStyles(ctx)
        pl.mothdigital.neuronowi.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        pl.mothdigital.neuronowi.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
